module.exports = __webpack_public_path__ + "img/userCard.75af38ac.png";